import {Spinner} from "react-bootstrap";
import React from "react";

const PageLoading = () => {
  return <Spinner animation="border" style={{position: 'fixed', right: 0, margin: 2}}/>
}

export default PageLoading;